var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.774,
    height: 27.835,
    viewBox: "0 0 89.774 27.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(0.404 0.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M966.234,514.536h6.761l8.874,27.3H975.7Zm16.733,22.742-3-9.227,3.127-13.515h3.042l7.057,27.3h-5.409l-3.042-13.323ZM995.01,539l-2.747-10.682,4.437-13.783h6.8Z",
    transform: "translate(-966.234 -514.536)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M992.327,541.278H986.3l-2.784-12.19L981.8,537.61l-3.373-10.373,3.191-13.794h3.518Zm-5.541-.537h4.794l-6.918-26.761H982.1l-3.062,13.235,2.628,8.082,1.824-9.013Zm-5.761.537h-6.783l-9.651-27.835h7.386Zm-6.348-.537h5.556l-8.7-26.761H965.4Zm19.051-1.547-3.01-11.707.022-.067,4.5-13.976h7.429Zm-2.4-11.691,2.483,9.656,8.047-23.179h-6.177Z",
    transform: "translate(-964.591 -513.443)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(33.594 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(0.403 0.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M1115.808,531.65l1.605,5.284H1111.5l-1.521,4.9h-7.014l8.493-24.579,3.042,10.031-1.226,4.365Zm5.662,10.184-8.282-27.3h5.916l9.381,27.3Z",
    transform: "translate(-1102.962 -514.536)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M1127.649,541.278h-7.643l-8.445-27.835h6.522l.065.189Zm-7.191-.537h6.386l-9.2-26.761h-5.309Zm-11.719.537h-7.417l8.915-25.8,3.331,10.98-1.151,4.1h2.38l1.769,5.82h-6.08l-1.521,4.9Zm-6.611-.537h6.387l1.521-4.9h5.752l-1.443-4.747h-2.691l1.3-4.63-2.754-9.082Z",
    transform: "translate(-1101.321 -513.443)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(59.581 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M1237.285,541.278h-7.607V530.558l-3.005,6.528-3.356-7.6.044-.1,7.047-15.942h6.877Zm-7.015-.537h6.422V513.98h-5.884l-6.854,15.505,2.729,6.182,3.586-7.791Zm-5.551.537h-4.788l-.076-.165-12.764-27.67h7.153l.075.168,11.37,25.6Zm-4.393-.537h4l.721-1.534-11.2-25.227h-5.862Zm-5.479.537h-7.607V518l7.607,16.483Zm-7.014-.537h6.422v-6.148l-6.422-13.915Z",
    transform: "translate(-1207.091 -513.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(60.026 0.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M1316.1,589.857a.418.418,0,0,0-.4.189.691.691,0,0,0-.058.319v.76h.887v-.741a.789.789,0,0,0-.054-.331A.372.372,0,0,0,1316.1,589.857Z",
    transform: "translate(-1289.414 -571.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M1208.9,559.112h7.015v-6.47l-7.015-15.2Z",
    transform: "translate(-1208.903 -531.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M1281.4,514.536l-6.972,15.774,3.043,6.891,3.3-7.159v11.792h7.014v-27.3Zm2.579,10.252,1.438-.684-1.438-.655v-.781l2.063,1.1h1.238v.689h-1.238l-2.063,1.141Zm0,1.159h.584v1.744h.7v-1.6h.573v1.6h.849v-1.825h.594v2.5h-3.3Zm0,5.056h1.36l-1.36-1.273v-.89l1.357,1.353,1.943-1.422v.885l-1.441,1.016.337.332h1.1v.678h-3.3Zm0,2.4a1.433,1.433,0,0,1,.085-.52.811.811,0,0,1,.23-.308,1.023,1.023,0,0,1,.278-.166.916.916,0,0,1,.346-.061.991.991,0,0,1,.463.118.663.663,0,0,1,.321.392.615.615,0,0,1,.261-.323,1.09,1.09,0,0,1,.516-.095h.221a1.7,1.7,0,0,0,.307-.018.277.277,0,0,0,.188-.127h.083v.76c-.073.021-.132.036-.177.045a1.644,1.644,0,0,1-.285.029l-.307,0a.623.623,0,0,0-.421.109.555.555,0,0,0-.106.393v.672h1.295v.673h-3.3Zm3.3,6.982h-2.716v.99h-.584v-2.67h.584v.986h2.716Zm-.453-2.245a1.7,1.7,0,0,1-.819.163h-2.029v-.7h2.027a1.152,1.152,0,0,0,.5-.08.669.669,0,0,0,0-1.085,1.142,1.142,0,0,0-.5-.08h-2.027v-.7h2.029a1.7,1.7,0,0,1,.819.163,1.519,1.519,0,0,1,0,2.32Z",
    transform: "translate(-1258.329 -514.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M1208.9,514.536l12.592,27.3h4.395l.845-1.8-11.325-25.5Z",
    transform: "translate(-1208.903 -514.536)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWam);
export default __webpack_public_path__ + "static/media/logo-wam.9a261dfa82b34ba770747b375bde5102.svg";
export { ForwardRef as ReactComponent };